import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Input,
  Select,
  Popconfirm,
  Space,
  Card,
  Flex,
} from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { getOrderItemDetails } from '../../../network/purchaseOrder';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getEncounterServicesAndItem } from '../../../network/Item';
import { queryKeys } from '../../../services/react-query/queryKeys';
const ItemListEncounter = ({ type, setDataSource, dataSource, t, form }) => {
  // console.log('dataSourcedwdwqdwqdwqdqwsd', dataSource);

  const [count, setCount] = useState(0);
  const [searchTxt, setSearchTxt] = useState('');
  const [debouncedSearchTxt, setDebouncedSearchTxt] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { mutate: onGetItemDetails } = useMutation({
    mutationFn: (itemName) => getOrderItemDetails('Material Request', itemName),
    onSuccess: (itemDetails) => {
      console.log(itemDetails, 'itemDetails');
      const newDataSource = [...dataSource];
      newDataSource[selectedIndex] = {
        ...newDataSource[selectedIndex],
        ...itemDetails?.message,
      };
      setDataSource(newDataSource);
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });
  const { data: itemsList, isLoading } = useQuery({
    queryKey: [queryKeys.getAllServicesAndItem, searchTxt],
    queryFn: () => getEncounterServicesAndItem(searchTxt),
    enabled: searchTxt?.length >= 3 || searchTxt?.length === 0,
    keepPreviousData: true,
  });
  console.log(itemsList, 'itemsList 222222');
  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTxt(searchTxt);
    }, 300);

    return () => clearTimeout(timerId);
  }, [searchTxt]);

  //  useEffect(() => {
  //    if (debouncedSearchTxt.length >= 3) {
  //      console.log('Searching for:', debouncedSearchTxt);

  //    }
  //  }, [debouncedSearchTxt]);

  useEffect(() => {
    const totalQty = dataSource.reduce(
      (total, item) => total + (Number(item.qty) || 0),
      0
    );
    const totalAmount = dataSource.reduce(
      (total, item) => total + (Number(item.amount) || 0),
      0
    );
    const netTotal = totalAmount;
    form.setFieldsValue({
      total_qty: totalQty,
      total: totalAmount,
      net_total: netTotal,
    });
  }, [dataSource]);
  console.log(type, 'typetype swww');
  const columns = [
    {
      title: t.items,
      dataIndex: 'item_code',
      render: (text, record, index) => (
        <Select
          // placeholder={t.items}
          placeholder={'search by name... '}
          style={{ width: '100%', minWidth: 200 }}
          value={
            record?.item_code
              ? {
                  key: record.item_code,
                  label: itemsList?.message?.find(
                    (i) => i.value === record.item_code
                  )?.description,
                }
              : undefined
          }
          labelInValue
          showSearch
          // optionFilterProp="children"
          popupMatchSelectWidth={false}
          onSearch={(value) => {
            setSearchTxt(value);
          }}
          filterOption={false}
          onChange={(value) => {
            setSelectedIndex(index);
            onGetItemDetails(value?.key);
          }}
          loading={isLoading}
          // options={itemsList?.message?.map((item) => ({
          //   value: item?.value,
          //   label: item?.value,
          // }))}
        >
          {itemsList?.message?.map((item) => (
            <Select.Option
              key={item?.value}
              value={item?.value}
              label={item?.description}
            >
              <Flex gap={1} vertical>
                <span>{item?.value}</span>
                <span
                  className="item-description"
                  style={{ fontSize: '11px', color: 'gray' }}
                >
                  {item?.description}
                </span>
              </Flex>
            </Select.Option>
          ))}
        </Select>
      ),
    },

    {
      title: t.quantity,
      dataIndex: 'qty',
      render: (text, record, index) => (
        <Input
          placeholder={t.quantity}
          type="number"
          // value={record.amount}
          value={record.qty}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              qty: e.target.value,
              amount:
                e.target.value * Number(record.rate - record.discount_amount),
            };
            setDataSource(newDataSource);
          }}
          min={0}
          // style={{ width: 140 }}
        />
      ),
    },
    {
      title: t.discountAmount,
      dataIndex: 'discount_amount',
      render: (text, record, index) => (
        <Input
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              discount_amount: e.target.value,
              amount: record?.qty * (record?.rate - e.target.value),
            };
            console.log(newDataSource, 'newDataSource');
            setDataSource(newDataSource);
          }}
          placeholder={t.discountAmount}
          type="number"
          value={record.discount_amount}
          min={0}
          width={100}
          // style={{ width: 120 }}
        />
      ),
    },
    {
      title: t.Rate,
      dataIndex: 'rate',
      render: (text, record, index) => (
        <Input
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              rate: e.target.value,
              amount: record?.qty * (e.target.value - record.discount_amount),
            };
            console.log(newDataSource, 'newDataSource');
            setDataSource(newDataSource);
          }}
          placeholder={t.Rate}
          type="number"
          value={record.rate}
          min={0}
          width={100}
          // style={{ width: 120 }}
        />
      ),
    },
    {
      title: t.amount,
      dataIndex: 'amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.amount}
          type="number"
          value={record.amount}
          min={0}
          width={100}
          disabled
          // style={{ width: 120 }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      warehouse: form.getFieldValue('set_warehouse'),
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default ItemListEncounter;
